
import Event = createjs.Event;

export class Poker2SliderEvent extends Event {
    public static ON_SLIDING: string = "onSliding";
    public static ARROW_UP: string = "slideUp";
    public static ARROW_DOWN: string = "slideDown";

    public percentValue: number = NaN;
    public numericValue: number = NaN;
    public buttonDown: boolean = false;
    /** Text input field value (if defined) of the slider has been changed. **/
    public onInputFieldChanged: boolean = false;

    constructor(type: string, percentValue: number, buttonDown: boolean, numericValue: number = 0, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.percentValue = percentValue;
        this.buttonDown = buttonDown;
        this.numericValue = numericValue;
    }
}
